<template>
    <button
        v-tippy="t('editorDeleteRow')"
        :class="[buttonState(editor.can().deleteRow()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().deleteRow()"
        @click="editor.chain().focus().deleteRow().run()"
    >
        <MdiTableRowRemove class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableRowRemove from 'materialdesignicons-vue3/icons/MdiTableRowRemove.js';

    defineExpose({
        name: 'DeleteTableRowButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
